module.exports = __webpack_public_path__ + "static/media/vuka-logo-dark.fa1ee661.svg";